"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_RESOURCE_DUPLICATE_TIMELIMIT = exports.BUFFER_DATA_TIMEOUT = exports.BUFFER_DATA_LIMIT = exports.HTTP_STATUS_CODE = exports.DEFAULT_LOGIC_STATUS_CODE = exports.UNKNOWN = exports.resourceTimingKeys = exports.OVERFLOW_VALUE = exports.INT_MAX = exports.resourceTypeMap = exports.initiatorTypeMap = exports.SupportInitiatorType = exports.supportGetEntriesByType = void 0;
exports.supportGetEntriesByType = typeof ((_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType) === 'function';
// 支持的标签类型
exports.SupportInitiatorType = ['script', 'link', 'img'];
exports.initiatorTypeMap = {
    script: 'script',
    link: 'css',
    img: 'image'
};
exports.resourceTypeMap = {
    script: 'js',
    css: 'css',
    image: /jpg|jpeg|png|svg|gif|ico/,
    json: 'json'
};
exports.INT_MAX = Math.pow(2, 63) - 1;
exports.OVERFLOW_VALUE = -1;
exports.resourceTimingKeys = [
    'connect_end',
    'connect_start',
    'decoded_body_size',
    'domain_lookup_end',
    'domain_lookup_start',
    'encoded_body_size',
    'fetch_start',
    'initiator_type',
    'next_hop_protocol',
    'redirect_end',
    'redirect_start',
    'request_start',
    'response_end',
    'response_start',
    'secure_connection_start',
    'time_origin',
    'transfer_size',
    'worker_start'
];
exports.UNKNOWN = 'unknown';
exports.DEFAULT_LOGIC_STATUS_CODE = 0;
exports.HTTP_STATUS_CODE = {
    SUCCESS: 200,
    FAILED: 400,
    /** 用于补充的数据 */
    PATCH: 10000
};
exports.BUFFER_DATA_LIMIT = 30;
// 10 minutes
exports.BUFFER_DATA_TIMEOUT = 600000;
// 20 s
exports.ERROR_RESOURCE_DUPLICATE_TIMELIMIT = 20000;
